module.exports = __webpack_public_path__ + "static/img/materialsax06.c35d00e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsax06.png
// module id = 1iLc
// module chunks = 2